import { i18n } from '@marine/i18n';
import { ORG_PERMISSION } from '../auth/orgPermissions';
import { useOrgPermission } from './useOrgPermission';

/** Shown beside the Private switch when it is locked, in both apps. */
export const checklistPublishOwnerOnly = () => i18n.t('checklists:publishOwnerOnly');

/**
 * Whether the user may make a checklist public or private again (MDC-4579): only the organization's
 * owner, the member who holds `manageMembers` in this release.
 *
 * The backend drops a member's change to `published_at` without a sync error, and saves a member's
 * new checklist private. So for a member the Private switch is locked on an existing checklist and
 * left out of a new one, and the forms don't write `published_at` for them at all.
 *
 * Fails closed like every `useOrgPermission` gate: an owner on a cold offline boot gets the member's
 * form until Clerk answers.
 */
export const useCanPublishChecklists = (): boolean => useOrgPermission(ORG_PERMISSION.manageMembers);
